import React, { useState } from "react";
import Link from "next/link";
import { IoArrowForward } from "react-icons/io5";
import * as s from "./index.module.scss";
import { PrismicRichText } from "@prismicio/react";
import secondaryFont from "@/utils/secondaryFont";
import { NextButton, PrevButton, usePrevNextButtons } from "./CarouselButtons";
import useEmblaCarousel from "embla-carousel-react";

import Popups from "../Common/Popups";

const BrandWeBuy = ({ title, description, brandTitle, brandTabBag }) => {
  const [showModal, setShowModal] = useState(false);
  const [emblaRef, emblaApi] = useEmblaCarousel({ loop: true });

  const {
    prevBtnDisabled,
    nextBtnDisabled,
    onPrevButtonClick,
    onNextButtonClick,
  } = usePrevNextButtons(emblaApi);

  return (
    <section className={`section-center ${s.brand_we_buy}`}>
      <div>
        <div className={s.title_text}>
          <h2 className="text-center fw-bold px-4">{title || ""}</h2>
          <div className={`px-4 ${secondaryFont} ${s.param}`}>
            <PrismicRichText field={description || []} />
          </div>
        </div>
        <div>
          <div className={s.content_box}>
            <div className={s.content_box_2}>
              <section className="embla_bags">
                <div className="overflow-hidden" ref={emblaRef}>
                  <div className="embla__container">
                    {brandTabBag.map((details, index) => (
                      <Slide details={details} key={index} />
                    ))}
                  </div>
                </div>

                <div className={s.buttons}>
                  <div className="embla__buttons">
                    <PrevButton
                      onClick={onPrevButtonClick}
                      disabled={prevBtnDisabled}
                    />
                    <NextButton
                      onClick={onNextButtonClick}
                      disabled={nextBtnDisabled}
                    />
                  </div>
                </div>
              </section>
            </div>
          </div>
        </div>
      </div>
      <div className={s.white_strip}></div>

      {/* Popup */}
      <Popups
        show={showModal}
        onHide={() => {
          setShowModal(false);
        }}
      />
    </section>
  );
};

export default BrandWeBuy;

const Slide = ({ details }) => {
  const { bag_logo, bag_model, bag_title, link_url, link_title, image_1 } =
    details;
  return (
    <div className="embla__slide">
      <div className={s.swiper_content}>
        <div className="">
          <img
            loading="lazy"
            src={image_1?.url}
            alt={bag_logo?.alt || image_1?.alt || bag_title || "image"}
            className={s.swiper_image}
          />
          <div className={s.text_style}>{bag_title}</div>
          <div className={s.button_area}>
            <button
              className="btn btn-primary me-2 mb-md-0"
              onClick={() => {
                setShowModal(true);
              }}
            >
              Get an offer now{" "}
              <IoArrowForward size="18px" style={{ marginLeft: "8px" }} />
            </button>
            {link_title && (
              <Link href={link_url} className="btn btn-outline-dark">
                {link_title}{" "}
                <IoArrowForward size="18px" style={{ marginLeft: "8px" }} />
              </Link>
            )}
          </div>
        </div>
        <img
          loading="lazy"
          src={bag_logo?.url}
          alt={bag_logo?.alt || image_1?.alt || bag_title || "image"}
          className={s.swiper_image}
        />
      </div>
    </div>
  );
};
